import { AiRunPage } from './AiRunsPage';

export default AiRunPage;
